import { getTableSettings$, setTableSettings$ } from "../Observables/TableSettings.observable";

export const getTableSettings = () => {
  return getTableSettings$();
};

export const setTableSettings = (tableSettings: any) => {
  setTableSettings$(tableSettings);
};
